<template>
  <div>
    <header-bar />
    <main>
      <div class="columns" style="overflow: hidden; margin: 0px;">
        <div
          class="column is-narrow"
          v-bind:style="addSubSystemStyleBackColor('width: 160px; padding: 12px 0px 10000px 12px; margin-bottom: -10000px;')"
        >
          <aside
            class="column is-50 is-narrow-mobile section"
            v-bind:style="addSubSystemStyleBackColor('padding: 0px;')"
          >
            <ul class="menu-list">
              <li v-for="menu in menuList" :key="menu.title">
                <template v-if="isVisibleMenu(menu)">
                  <template>
                    <router-link
                      v-if="(menu.title != 'マスタメンテナンス') || (menu.title == 'マスタメンテナンス' && menu.roleList.includes(roleType))"
                      :to="menu.href"
                      v-bind:style="addSubSystemStyleBackColor('')"
                      :class="{ 'is-active': activeNum == 0 }"
                      @click="changeActiveLink(0)"
                    >
                      <span class="icon" style="color: #fff; height: 45px;">
                        <i v-bind:class="[menu.icon]" style="position: relative;"></i>
                        <i
                          style="position: absolute;"
                          v-if="menu.iconOverlay"
                          v-bind:class="[menu.iconOverlay] "
                        ></i>
                      </span>
                      <div style="font-size: 12px; color: #fff;">{{ menu.title }}</div>
                    </router-link>
                    <ul v-if="roleType!=7">
                      <li v-for="child in menu.child" :key="child.title">
                        <router-link
                          :to="child.href"
                          v-bind:style="addSubSystemStyleBackColor('')"
                          :class="{ 'is-active': activeNum == 0 }"
                          @click="changeActiveLink(0)"
                        >
                          <p style="font-size: 12px; color: #fff;">{{ child.title }}</p>
                        </router-link>
                      </li>
                    </ul>
                  </template>
                </template>
              </li>
            </ul>
          </aside>
        </div>

        <div class="column" style="background-color: white; min-height: 1000px;width: calc(100% - 160px);">
          <div>
            <router-view></router-view>
          </div>
        </div>
      </div>
    </main>
    <go-to-top/>
  </div>
</template>

<script>
import Vue from "vue";
import Header from "./header";
Vue.component("header-bar", Header);
import GoToTop from "./pageTop";
Vue.component("go-to-top", GoToTop);

var menuList = require("@/data/menu.json");

export default {
  name: "Index",
  data() {
    var env = this.$store.state.env;
    console.log(env);
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleType = userInfo.srcRoleId;
    return {
      activeNum: 0,
      roleType,
      env,
    };
  },
  methods: {
    changeActiveLink(val) {
      activeNum = val;
    },
    isVisibleMenu(menu) {
      if (menu.title == "マスタメンテナンス") {
        return true;
      }
      var roleList = menu.roleList;
      return roleList.includes(this.roleType);
    },
  },

  computed: {
    menuList: function() {
      const subSystem = this.$store.state.subSystem;
      let _menuList = JSON.parse(JSON.stringify(menuList[subSystem.keyName]));

      const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
      if (userInfo.system.patientDb.disable) {
        _menuList = _menuList.filter((elem) => !elem.patientDb);
      }
      if (userInfo.system.disaster.disable) {
        _menuList = _menuList.filter((elem) => !elem.disaster);
      }

      return _menuList;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/index.vue